import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';
import { StatementDocumentTypesEnum } from '../statement-data.data';

export const STATEMENT_DOCUMENT_SCHEMA = Object.freeze({
  ID: '',
  REVISION_ID: '',
  DOC_TYPE: '', // invoice || credit_memo
  DOC_DATE: '', // i2g-timezoneless-date (yyyy-mm-dd)
  DOC_NUMBER: null, // ''
  DUE_DATE: null, // i2g-timezoneless-date (yyyy-mm-dd)
  IS_OVERDUE: false,
  AMOUNT: 0,
  PAID: 0,
  BALANCE: 0,
  PAYMENTS_FEES_PAID: 0,
  CARD_PAYMENTS_DISABLED: true,
  PAYPAL_EC_DISABLED: true,
  ELECTRONIC_PAYMENT_URL: '',
});
const RECORD = generateSchema(STATEMENT_DOCUMENT_SCHEMA);
const KEYS: any = generateKeys(STATEMENT_DOCUMENT_SCHEMA);

export class StatementDocument extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get revisionId(): string {
    return this.get(KEYS.REVISION_ID);
  }

  get docType(): StatementDocumentTypesEnum {
    return this.get(KEYS.DOC_TYPE);
  }

  get docDate(): string {
    return this.get(KEYS.DOC_DATE);
  }

  get docNumber(): string {
    return this.get(KEYS.DOC_NUMBER);
  }

  get dueDate(): string {
    return this.get(KEYS.DUE_DATE);
  }

  get isOverdue(): boolean {
    return this.get(KEYS.IS_OVERDUE);
  }

  get amount(): number {
    return this.get(KEYS.AMOUNT);
  }

  get paid(): number {
    return this.get(KEYS.PAID);
  }

  get balance(): number {
    return this.get(KEYS.BALANCE);
  }

  get paymentsFeesPaid(): number {
    return this.get(KEYS.PAYMENTS_FEES_PAID);
  }

  get cardPaymentsDisabled(): boolean {
    return this.get(KEYS.CARD_PAYMENTS_DISABLED);
  }

  get paypalEcDisabled(): boolean {
    return this.get(KEYS.PAYPAL_EC_DISABLED);
  }

  get electronicPaymentUrl(): string {
    return this.get(KEYS.ELECTRONIC_PAYMENT_URL);
  }
}
